import { ChecklistItem } from '@/src/common/modules/OnboardingChecklist/ChecklistItem'
import { formatToTextMonth } from '@/src/common/utils/date'
import * as E2E from '../e2e'
import * as Navigation from '../navigation'

export function OnboardingChecklistItem({
  awardAmountInPoints,
  periodEnd,
  status,
}: {
  awardAmountInPoints: number
  periodEnd: Date | string | undefined
  status: 'complete' | 'needs_upload' | 'in_review' | 'rejected' | 'unenrolled'
}) {
  const statementPointsDescription = periodEnd
    ? `Points issued day after statement close (${formatToTextMonth(new Date(periodEnd))})`
    : ''

  let description: string = ''

  const defaultDescription = `Mesa has paired your mortgage data for ${awardAmountInPoints} points per month. ${statementPointsDescription}`

  switch (status) {
    case 'complete':
      description = defaultDescription
      break

    case 'needs_upload':
      description = 'Please upload a mortgage statement to submit your updated mortgage amount.'
      break

    case 'in_review':
      description = 'Mesa is currently reviewing your mortgage document.'
      break

    case 'rejected':
      description = 'Mortgage document is not valid, please upload a new mortgage statement.'
      break

    case 'unenrolled':
      description = 'You are not enrolled in the Mesa Home program.'
      break
  }

  return (
    <ChecklistItem
      title="Mortgage Rewards"
      description={description}
      status={status === 'complete' ? 'complete' : 'incomplete'}
      linkProps={{
        href: Navigation.Routes.MortgageEarn.route,
        testID: E2E.Config.Ids.Press.CheckListItem,
      }}
    />
  )
}
